(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > 150) {
        this.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      } else if (scrollTop < this.currentScrollTop && scrollTop > 150) {
        this.classList.add('shopify-section-header-sticky');
        this.classList.remove('shopify-section-header-hidden');
      } else if (scrollTop <= 150) {
        this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* KS Verse - Popup-window login for nav account triggers.
     Keeps the customer on the current page instead of a full-page redirect
     to accounts.ksverse.in. Uses the existing /pages/login-callback page,
     which signals completion via BroadcastChannel + localStorage. */
  (function () {
    function openLoginPopup(trigger) {
      var w = 480, h = 680;
      var left = window.screenX + Math.max(0, (window.outerWidth - w) / 2);
      var top = window.screenY + Math.max(0, (window.outerHeight - h) / 2);
      var baseUrl = trigger.href.split('?')[0];
      var loginUrl = baseUrl + '?return_to=' + encodeURIComponent('/pages/login-callback');

      var popup = window.open(
        loginUrl,
        'ks_login',
        'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',resizable=yes,scrollbars=yes'
      );

      if (!popup) {
        window.location.href = trigger.href;
        return;
      }

      var finished = false;
      var bc = null;
      try { bc = new BroadcastChannel('ks_login'); } catch (err) {}

      function finish() {
        if (finished) return;
        finished = true;
        window.removeEventListener('storage', onStorage);
        if (bc) { bc.onmessage = null; try { bc.close(); } catch (err) {} }
        clearInterval(pollTimer);
        window.location.reload();
      }

      function onStorage(ev) {
        if (ev.key === 'ks_login_done') finish();
      }
      window.addEventListener('storage', onStorage);

      if (bc) {
        bc.onmessage = function (ev) {
          if (ev.data === 'done') finish();
        };
      }

      var pollTimer = setInterval(function () {
        if (popup.closed) finish();
      }, 500);
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ks-popup-login]');
      if (!trigger) return;
      e.preventDefault();
      openLoginPopup(trigger);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
